// src/Mainpage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

function Mainpage() {
  const navigate = useNavigate();

  // ✅ Logout function
  const handleLogout = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.clear();
    } catch (e) {
      // ignore errors
    }

    navigate("/login"); // redirect to login page
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 font-sans">

      {/* Header */}
      <header className="max-w-6xl mx-auto px-4 py-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="bg-indigo-600 text-white rounded-full w-12 h-12 flex items-center justify-center text-xl shadow-lg">
            🎮
          </div>

          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
              Fun Games Hub
            </h1>
            <p className="text-sm text-gray-500">Play · Chill · Compete</p>
          </div>
        </div>

        <div className="flex items-center gap-3">

          <button
            onClick={() => navigate("/profile")}
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg shadow-sm text-sm text-gray-700 hover:shadow-md transition"
          >
            👤 Profile
          </button>

          {/* ✅ FIXED: using handleLogout */}
          <button
            onClick={handleLogout}
            className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg shadow-md hover:bg-red-700 transition"
          >
            🔒 Logout
          </button>

        </div>
      </header>

      {/* Hero */}
      <section className="max-w-6xl mx-auto px-4">
        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-xl flex flex-col md:flex-row items-center gap-6">

          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 leading-tight">
              🎯 Ready to have some fun?
            </h2>
            <p className="mt-3 text-gray-500 max-w-xl">
              Choose a game and start playing. Small challenges, big smiles.
            </p>
          </div>

          <div className="w-full md:w-80">
            <div className="bg-gradient-to-tr from-indigo-50 to-indigo-100 border border-indigo-100 rounded-xl p-4 shadow-inner">
              <h3 className="text-lg font-semibold text-gray-700">Quick Tips</h3>
              <ul className="mt-3 text-sm text-gray-600 space-y-2">
                <li>• Use headphones for best experience.</li>
                <li>• Scores autosave while you play.</li>
                <li>• Invite friends to beat your score!</li>
              </ul>
            </div>
          </div>

        </div>
      </section>

      {/* Game Cards */}
      <main className="max-w-6xl mx-auto px-4 mt-8 pb-16">
        <h4 className="text-lg text-gray-700 mb-4 font-medium">Games</h4>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

          {/* Guess Game */}
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition">
            <h5 className="text-lg font-semibold">Guess the Lucky Number 🔢</h5>
            <button
              onClick={() => navigate("/guess")}
              className="mt-4 w-full px-4 py-2 bg-indigo-600 text-white rounded-md"
            >
              Play
            </button>
          </div>

          {/* Color Game */}
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition">
            <h5 className="text-lg font-semibold">Color Guess Game 🎨</h5>
            <button
              onClick={() => navigate("/color")}
              className="mt-4 w-full px-4 py-2 bg-emerald-600 text-white rounded-md"
            >
              Play
            </button>
          </div>

          {/* Typing Game */}
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition">
            <h5 className="text-lg font-semibold">Typing Game ⌨️</h5>
            <button
              onClick={() => navigate("/typing")}
              className="mt-4 w-full px-4 py-2 bg-amber-500 text-white rounded-md"
            >
              Play
            </button>
          </div>

        </div>
      </main>

      <footer className="text-center pb-6 text-gray-500 text-sm">
        Made with ❤️ — Good luck and have fun!
      </footer>

    </div>
  );
}

export default Mainpage;
